import axios from 'axios';
import { useContext } from 'react';
import { ReactSession } from 'react-client-session';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { UpdateLocalAccessToken, getLocalToken } from './TokenServices';

ReactSession.setStoreType("sessionStorage");

const BASE_URL_LIVE = 'https://logbook.tpf.go.tz/api'
const BASE_URL_TEST = 'http://localhost:86/csmit/api'


let headers = {};

const AxiosHelper = axios.create({
    baseURL:BASE_URL_LIVE,
    headers
});


AxiosHelper.interceptors.request.use(
    async (config) => {
        
        const token = await ReactSession.get("csmit_token");
        
        if(token){
            config.headers.authorization = token;
        }

        return config;

},(error) => {
    return Promise.reject(error);
});

AxiosHelper.interceptors.response.use(
    (response) => new Promise(
        (resolve,reject) => {
            resolve(response)
        }), 
        async (error) => {
            const originalConfig = error?.config;

            // Access Token was expired
            if(error?.response?.status === 403 && !originalConfig._retry){
                originalConfig._retry = true;

                try{
                    //Send request for requesting new token
                    const rs = await AxiosHelper.post("/users/auth/refreshtoken", {
                        refreshToken: getLocalToken(),
                    });

                    //Update the token in the localstorage
                    UpdateLocalAccessToken(rs?.data);

                    return AxiosHelper(originalConfig);
                }catch(_error){
                    return Promise.reject(_error);
                }
            }

            return Promise.reject(error);
        }
);


export default AxiosHelper;
